module.exports = __webpack_public_path__ + "img/CentOs.06cebdc.svg";